import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';

const StudentManagementTab = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedBatch, setSelectedBatch] = useState('all');
  const [selectedDepartment, setSelectedDepartment] = useState('all');

  const batchOptions = [
    { value: 'all', label: 'All Batches' },
    { value: '2024-2028', label: 'B.Tech 2024-2028' },
    { value: '2023-2027', label: 'B.Tech 2023-2027' },
    { value: '2022-2026', label: 'B.Tech 2022-2026' },
    { value: '2021-2025', label: 'B.Tech 2021-2025' }
  ];

  const departmentOptions = [
    { value: 'all', label: 'All Departments' },
    { value: 'cse', label: 'Computer Science' },
    { value: 'ece', label: 'Electronics & Communication' },
    { value: 'mech', label: 'Mechanical Engineering' },
    { value: 'civil', label: 'Civil Engineering' }
  ];

  const batches = [
    {
      id: 1,
      name: 'B.Tech CSE 2024-2028',
      department: 'Computer Science',
      totalStudents: 120,
      activeStudents: 118,
      avgCGPA: 8.2,
      placementEligible: 0,
      placed: 0,
      coordinator: 'Dr. Rajesh Kumar'
    },
    {
      id: 2,
      name: 'B.Tech CSE 2023-2027',
      department: 'Computer Science',
      totalStudents: 115,
      activeStudents: 112,
      avgCGPA: 8.5,
      placementEligible: 110,
      placed: 45,
      coordinator: 'Dr. Priya Sharma'
    },
    {
      id: 3,
      name: 'B.Tech CSE 2022-2026',
      department: 'Computer Science',
      totalStudents: 110,
      activeStudents: 108,
      avgCGPA: 8.3,
      placementEligible: 108,
      placed: 78,
      coordinator: 'Dr. Amit Patel'
    },
    {
      id: 4,
      name: 'B.Tech CSE 2021-2025',
      department: 'Computer Science',
      totalStudents: 105,
      activeStudents: 103,
      avgCGPA: 8.6,
      placementEligible: 103,
      placed: 95,
      coordinator: 'Dr. Sneha Reddy'
    }
  ];

  const topPerformers = [
    {
      id: 1,
      name: 'Rahul Verma',
      batch: 'B.Tech CSE 2022-2026',
      cgpa: 9.8,
      skills: ['React', 'Node.js', 'Python'],
      certifications: 5,
      projects: 8
    },
    {
      id: 2,
      name: 'Ananya Singh',
      batch: 'B.Tech CSE 2022-2026',
      cgpa: 9.7,
      skills: ['Java', 'Spring Boot', 'AWS'],
      certifications: 6,
      projects: 7
    },
    {
      id: 3,
      name: 'Karthik Reddy',
      batch: 'B.Tech CSE 2023-2027',
      cgpa: 9.6,
      skills: ['Flutter', 'Firebase', 'UI/UX'],
      certifications: 4,
      projects: 6
    }
  ];

  return (
    <div className="space-y-6">
      <div className="flex flex-col md:flex-row gap-4">
        <div className="flex-1">
          <Input
            type="text"
            placeholder="Search students, batches, or coordinators..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e?.target?.value)}
          />
        </div>
        <Select
          options={batchOptions}
          value={selectedBatch}
          onChange={setSelectedBatch}
          className="w-full md:w-48"
        />
        <Select
          options={departmentOptions}
          value={selectedDepartment}
          onChange={setSelectedDepartment}
          className="w-full md:w-48"
        />
        <Button variant="outline" iconName="Download">
          Export Report
        </Button>
      </div>

      <div className="grid grid-cols-1 gap-4">
        {batches?.map((batch) => (
          <div key={batch?.id} className="bg-background rounded-lg p-6 border border-border hover:border-primary transition-smooth">
            <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
              <div className="flex-1">
                <div className="flex items-start justify-between mb-3">
                  <div>
                    <h3 className="text-lg font-heading font-semibold text-foreground">{batch?.name}</h3>
                    <p className="text-sm text-muted-foreground mt-1">
                      Coordinator: {batch?.coordinator}
                    </p>
                  </div>
                  <span className="px-3 py-1 bg-primary/10 text-primary text-xs font-medium rounded-full">
                    {batch?.department}
                  </span>
                </div>
                <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-4">
                  <div>
                    <p className="text-xs text-muted-foreground">Total Students</p>
                    <p className="text-lg font-semibold text-foreground">{batch?.totalStudents}</p>
                  </div>
                  <div>
                    <p className="text-xs text-muted-foreground">Active</p>
                    <p className="text-lg font-semibold text-success">{batch?.activeStudents}</p>
                  </div>
                  <div>
                    <p className="text-xs text-muted-foreground">Avg. CGPA</p>
                    <p className="text-lg font-semibold text-foreground">{batch?.avgCGPA}</p>
                  </div>
                  <div>
                    <p className="text-xs text-muted-foreground">Eligible</p>
                    <p className="text-lg font-semibold text-foreground">{batch?.placementEligible}</p>
                  </div>
                  <div>
                    <p className="text-xs text-muted-foreground">Placed</p>
                    <p className="text-lg font-semibold text-success">{batch?.placed}</p>
                  </div>
                  <div>
                    <p className="text-xs text-muted-foreground">Placement %</p>
                    <p className="text-lg font-semibold text-foreground">
                      {batch?.placementEligible > 0 ? Math.round((batch?.placed / batch?.placementEligible) * 100) : 0}%
                    </p>
                  </div>
                </div>
              </div>
              <div className="flex flex-wrap gap-2">
                <Button variant="outline" size="sm" iconName="Users">
                  View Students
                </Button>
                <Button variant="outline" size="sm" iconName="BarChart3">
                  Analytics
                </Button>
                <Button variant="outline" size="sm" iconName="FileText">
                  Reports
                </Button>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="bg-background rounded-lg p-6 border border-border">
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-lg font-heading font-semibold text-foreground">Top Performers</h3>
          <Button variant="ghost" size="sm" iconName="Award">
            View All
          </Button>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {topPerformers?.map((student) => (
            <div key={student?.id} className="p-4 rounded-lg border border-border hover:border-primary transition-smooth">
              <div className="flex items-start justify-between mb-3">
                <div>
                  <h4 className="text-base font-medium text-foreground">{student?.name}</h4>
                  <p className="text-sm text-muted-foreground">{student?.batch}</p>
                </div>
                <div className="px-2 py-1 bg-success/10 text-success text-xs font-bold rounded">
                  {student?.cgpa} CGPA
                </div>
              </div>
              <div className="space-y-2">
                <div className="flex items-center gap-2 text-sm">
                  <Icon name="Award" size={14} color="var(--color-muted-foreground)" />
                  <span className="text-muted-foreground">{student?.certifications} Certifications</span>
                </div>
                <div className="flex items-center gap-2 text-sm">
                  <Icon name="Folder" size={14} color="var(--color-muted-foreground)" />
                  <span className="text-muted-foreground">{student?.projects} Projects</span>
                </div>
                <div className="flex flex-wrap gap-1 mt-2">
                  {student?.skills?.slice(0, 3)?.map((skill, idx) => (
                    <span key={idx} className="px-2 py-1 bg-muted text-xs text-foreground rounded">
                      {skill}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default StudentManagementTab;